/**
 * Legacy setup route — redirects to unified provision workspace (continue setup).
 */

import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useLanguage } from '@/state/language/LanguageProvider';

const AIStudioInstanceSetupPage: React.FC = () => {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const { instanceId } = useParams<{ instanceId: string }>();

  useEffect(() => {
    if (instanceId) {
      navigate(`/ai-studio/instances/${instanceId}/provision`, { replace: true });
    }
  }, [instanceId, navigate]);

  return (
    <main className="px-4 py-4 md:px-6 lg:px-8">
      <p className="text-base text-[var(--color-surface-text-secondary)]">
        {t('aiStudio.instanceSetup.loading')}
      </p>
    </main>
  );
};

export default AIStudioInstanceSetupPage;
